export const libVersion = {
  "name": "@gea/digital-ui-lib",
  "version": "20.0.3"
};
